import { distributionTemplateInitialStatus as initialStatus } from './distributionTemplateInitialStatus';
import { distributionTemplateInitialValues as initialValues } from './distributionTemplateInitialValues';

export default { initialStatus, initialValues };
